
import styled from 'styled-components';
import Link from '@mlb/react-patterns/v4/components/Link/link';
import { ImageWrapper } from '@mlb/react-patterns/v4/components/Image/image.style';
import { HighlightsDivider } from '../Highlights/Highlights.style';
export const TitleWrapper = styled.div`
    text-transform: uppercase;
    color: var(--gameday-title-color);
`;

export const RecapWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    font-size: 18px;
    font-weight: bold;
    display: grid;
    grid-template-columns: ${({ $isMobile }) => $isMobile ? '1fr' : '1fr 1fr'};

    a {
        color: var(--gameday-recap-color);
    }
    p {
        color: var(--gameday-recap-color);
        font-weight: 500;
        font-size: 18px;
        margin: 0;
        margin-top: 15px;
    }

    & + ${HighlightsDivider} {
        visibility: visible;
    }

`;

export const ArticleTitle = styled(Link)`
    color: var(--gameday-recap-color);
    font-size: 24px;
    line-height: 30px;
    font-weight: bold;
    display: block;
    cursor: pointer;
    &:hover {
        color: var(--gameday-link-color) !important;
    }
`;

export const EllipsisWrapper = styled.span`
    &:after {
        content: '...';
        padding: 0 4px;
    }
`;

export const LinkOverride = styled(Link)` 
    color: var(--gameday-link-color) !important; //Override basesite styling
    font-size: 14px;
    font-weight: bold;
    padding: ${({ $isMobile }) => $isMobile ? '0' : 'var(--gameday-section-padding-sm) 0 var(--gameday-section-padding-sm) var(--gameday-section-padding-sm)'};

    ${ImageWrapper} {
        height: 100%;
        overflow: hidden;
        border-radius: 8px;
        ${({ $isMobile }) => $isMobile && `
            border-bottom-left-radius: 0px;
            border-bottom-right-radius: 0px;
        `}
        img {
            border-radius: 8px;
            object-fit: cover;
            height: 100%;
            width: 100%;
            ${({ $isMobile }) => $isMobile && `
                border-bottom-left-radius: 0px;
                border-bottom-right-radius: 0px;
            `}
        }
    }

`;

export const TextWrapper = styled.div`
    padding: var(--gameday-section-padding-sm);

    ${({ $headline }) => !$headline && `
        margin-top: -30px;
    `}

    ${LinkOverride} {
        padding: 0;

        p {
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;  
            overflow: hidden;
        }
    }

`;

export const SkeletonWrapper = styled.div`
    padding: var(--gameday-section-padding-sm);
`;
